import { useEffect } from "react";
import { Navigate, useLocation } from "react-router";
import AuthLayout from "@/components/layout/auth-layout";
import LandingLayout from "@/components/layout/landing-layout";
import MainLayout from "@/components/layout/main-layout";
import MenuLayout from "@/components/layout/menu-layout";
import "@/utils/extension.util";
import { useAppSelector } from "./store/hooks";

const Application = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const mode = useAppSelector((state) => state.theme.mode);
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = mode === "light" ? "dark" : "light";
    const root = window.document.documentElement;
    root.classList.remove(prev);
    root.classList.add(mode);
  }, [mode]);

  // Customer-facing QR menu — always public.
  if (pathname.startsWith("/a-la-carte-menu")) return <MenuLayout />;

  // Auth screens (login, forgot/reset password, verify email).
  if (pathname.startsWith("/auth")) return <AuthLayout />;

  // The admin app lives under /dashboard and requires authentication.
  if (pathname.startsWith("/dashboard")) {
    return isAuthenticated ? <MainLayout /> : <Navigate to="/auth/login" replace />;
  }

  // Everything else (the root "/") is the public landing site.
  return <LandingLayout />;
};

export default Application;
